import * as React from "react";
import { Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpArrayObject } from "../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemAllowOrigin } from "./CpArrayItemAllowOrigin";
import { DomainPortCorsAllowOriginInput } from "../../../../schema/types/domain/input";
import { v4 as uuidv4 } from "uuid";
import { CpArrayString } from "../../../gvc/testNewForm/CpArrayString";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";

interface Props {
  index: number;
}
export const PortCors: React.FC<Props> = ({ index }) => {
  const configureCors = useCpFormValue(`advanced.spec.ports.${index}.cors.isEnabled`);

  return (
    <div key={`port-cors-${index}`}>
      <Divider orientation="left" orientationMargin={0}>
        CORS
      </Divider>
      <CpFormItem>
        <div className="flex items-center gap-2">
          <CpLabel name={`advanced.spec.ports.${index}.cors.isEnabled`}>Configure CORS</CpLabel>
          <CpSwitch name={`advanced.spec.ports.${index}.cors.isEnabled`} />
        </div>
      </CpFormItem>
      {configureCors ? (
        <>
          <CpFormItem>
            <div className="flex items-center gap-2">
              <CpLabel name={`advanced.spec.ports.${index}.cors.allowCredentials`}>Allow Credentials</CpLabel>
              <CpSwitch name={`advanced.spec.ports.${index}.cors.allowCredentials`} />
            </div>
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`advanced.spec.ports.${index}.cors.maxAge`}>Max Age</CpLabel>
            <CpInput name={`advanced.spec.ports.${index}.cors.maxAge`} style={{ maxWidth: 600 }} />
            <CpErrorWarning name={`advanced.spec.ports.${index}.cors.maxAge`} />
          </CpFormItem>
          <div style={{ maxWidth: 600 }}>
            <CpArrayObject
              factoryFn={() => {
                const newItem: DomainPortCorsAllowOriginInput = {
                  id: uuidv4(),
                  type: "exact",
                  value: "",
                };
                return newItem;
              }}
              label={"Allow Origins"}
              labels={[
                { label: "Type", span: 1 },
                { label: "Value", span: 3 },
              ]}
              name={`advanced.spec.ports.${index}.cors.allowOrigins`}
            >
              <CpArrayItemAllowOrigin />
            </CpArrayObject>
          </div>
          <div style={{ maxWidth: 600 }}>
            <CpArrayString label="Allow Methods" name={`advanced.spec.ports.${index}.cors.allowMethods`} />
          </div>
          <div style={{ maxWidth: 600 }}>
            <CpArrayString label="Allow Headers" name={`advanced.spec.ports.${index}.cors.allowHeaders`} />
          </div>
          <div style={{ maxWidth: 600 }}>
            <CpArrayString label="Expose Headers" name={`advanced.spec.ports.${index}.cors.exposeHeaders`} />
          </div>
        </>
      ) : null}
    </div>
  );
};
